export const BANKING_FORM_CRITERIA = {
  BANK_NAME_MIN_LENGTH: 2,
  BANK_NAME_MAX_LENGTH: 32,
  BANK_ACCOUNT_NO_MIN_LENGTH: 3,
  BANK_ACCOUNT_NO_MAX_LENGTH: 19
}
